import {createGlobalStyle} from 'styled-components';

const mainFont = 'Open Sans, sans-serif';
const mainFontSize = '14px';

export const GlobalStyle = createGlobalStyle`
  * {
      box-sizing: border-box;
    }

    // Клас вішається на час перемикання теми, щоб кольори мінялись миттєво, а не через transition: all
    html.theme-switching *,
    html.theme-switching *::before,
    html.theme-switching *::after {
      transition: none !important;
    }
   
    html, body {
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      font-family: ${mainFont};
      font-size: ${mainFontSize};
      color: ${({theme}) => theme.body.color};
      background: ${({theme}) => theme.body.background};
    }
    
    h1,h2,h3,h4,h5,h6,p,span,select,input {
      margin: 0;
      padding: 0;
      border: none;
      outline: none;
    }
    
    ul, ol {
      margin: 0;
      padding: 0;
      list-style: none;
    }
    
    input, select {
      color: ${({theme}) => theme.body.color};
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-box-shadow: inset 0 0 0 50px ${({theme}) => theme.input.autofillBackground};
      -webkit-text-fill-color: ${({theme}) => theme.input.color};
      caret-color: ${({theme}) => theme.input.color};
    }

    @media (max-width: 768px) {
      input, select, textarea {
        font-size: 16px;
      }
    }
    
    button {
      padding: 0;
      font: inherit;
      background-color: transparent;
      cursor: pointer;
    }
    
    a {
      color: inherit;
      text-decoration: none;
      transition: all .3s ease;
    }
    a:hover {
      color: ${({theme}) => theme.link.hover};
    }
    a:hover, a:focus, a:active {
      text-decoration: none;
    }
    
    a.default-link {
      color: ${({theme}) => theme.link.color};
      transition: all .1s ease;
      &:hover {
        text-decoration: underline;
      }
    }
    p {
    text-align: justify;
    }
    
    //Progressbar custom style
    #nprogress .bar {
      height: 5px;
      background: ${({theme}) => theme.brand.progress};
      z-index: 1999;
    }
    #nprogress .peg {
      box-shadow: 0 0 10px ${({theme}) => theme.brand.progress}, 0 0 5px ${({theme}) => theme.brand.progress};
    }
    #nprogress .spinner-icon {
      border-top-color: ${({theme}) => theme.brand.progress};
      border-left-color: ${({theme}) => theme.brand.progress};
    }

  .dropdown-filter-with-date {
    .MuiMenuItem-root {
      overflow: inherit;
    }
    .MuiPopover-paper {
      overflow-x: hidden;
      overflow-y: auto;
    }
    ul {
      min-width: 295px;
    }
  }

  .example-csv {
    b {
      padding-bottom: 5px;
      display: inline-flex;
    }
    a {
      padding: 5px 0;
      display: inline-flex;
      text-decoration: underline;
    }
  }

  // Перемикач теми в дропдауні — лише на мобільних, на десктопі для цього є кнопка в шапці.
  // Брейкпоінт мусить збігатись з тим, на якому ховається StyledToolbarButton
  .toolbar-dropdown .toolbar-dropdown__item_theme {
    display: none;
  }
  @media screen and (max-width: 600px) {
    .toolbar-dropdown .toolbar-dropdown__item_theme {
      display: flex;
    }
  }

  #menu-lang ul {
    .lang-select__pref {
      display: none;
    }
  }
  
  .exchanger-select {
    &__option {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .balance {
        max-width: 45%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
`;